export const NEWSROOM_CATEGORY = 'Newsroom' as const;

// Fallback when a post has no contentType frontmatter field.
const CATEGORY_FALLBACK: Record<string, string> = {
  'Patient Engagement': 'Spotlight',
  'Patient Access': 'Spotlight',
  'Mental Health': 'Spotlight',
  'Telehealth': 'Spotlight',
  'Newsroom': 'Newsroom',
};

export const VALID_EDITORIAL = new Set([
  'Insights',
  'Spotlight',
  'Product',
  'Conversations',
  'Case Study',
  'Newsroom',
]);

/**
 * Returns the editorial label for a post.
 * Prefer the explicit contentType frontmatter field when present.
 */
// 'Customers' is a legacy alias for the 'Spotlight' editorial tab
const CONTENT_TYPE_ALIAS: Record<string, string> = {
  'Customers': 'Spotlight',
};

export function toEditorial(raw: string, contentType?: string): string {
  if (raw === NEWSROOM_CATEGORY) return 'Newsroom';
  if (contentType && CONTENT_TYPE_ALIAS[contentType]) return CONTENT_TYPE_ALIAS[contentType];
  if (contentType && VALID_EDITORIAL.has(contentType)) return contentType;
  return CATEGORY_FALLBACK[raw] ?? 'Insights';
}

export const EDITORIAL_TO_SLUG: Record<string, string> = {
  'Insights': 'insights',
  'Spotlight': 'customers',
  'Product': 'product',
  'Conversations': 'conversations',
  'Case Study': 'case-study',
  'Newsroom': 'newsroom',
};

export function toCategorySlug(raw: string, contentType?: string): string {
  return EDITORIAL_TO_SLUG[toEditorial(raw, contentType)] ?? 'insights';
}